// Invoice Document component for PDF generation using @react-pdf/renderer
// Receives a single canonical InvoiceDisplayModel (from invoiceViewModel.js)
// and delegates to the correct layout via the registry.
import React from "react";
import { getLayoutComponent } from "./invoice/layoutRegistry";

const InvoiceDocumentPdf = ({ model }) => {
  const layoutType = model?.template?.layout_type || "classic";
  const LayoutComponent = getLayoutComponent(layoutType);
  return <LayoutComponent model={model} />;
};

InvoiceDocumentPdf.displayName = "InvoiceDocumentPdf";

export default InvoiceDocumentPdf;
